package br.com.vvrefeicoes.portal.domain.model

data class JuridicoHistoricoSyncStatus(
    val executionsToday: Long = 0,
    val dailyLimit: Long = 3,
) {
    val canSynchronize: Boolean get() = executionsToday < dailyLimit
}
